export default class SupplierOrder {
    constructor() {
        this.id = "";
        this.identification = "";
        this.number = 0;
        this.status = 1;
        this.collaborator = { id: "", content: "" };
        this.customer = { id: "", content: "" };
        this.contact = { id: "", content: "" };
        this.rentId = "";
        this.rent = {};
        this.deliveryDateHour = "";
        this.startDateHour = "";
        this.endDateHour = "";
        this.devolutionDateHour = "";
        this.launchProducts = false;
        this.archived = false;
        this.observation = "";
        this.total = 0;
        this.totalPayment = 0;
    }
    update(data) {
        this.id = data.id;
        this.identification = data.identification;
        this.number = data.number;
        this.status = data.status;

        if (data.collaborator)
            this.collaborator = { id: data.collaborator.id, content: data.collaborator.person.companyName + " (" + data.collaborator.person.tradeName + ")" };

        this.customer = { id: data.customerSupplier.id, content: data.customerSupplier.person.companyName + " (" + data.customerSupplier.person.tradeName + ")" };
        this.contact = { id: data.contact.id, content: data.contact.name };

        if (data.rent != null) {
            const identification = data.rent.identification ? ` - ${data.rent.identification}` : '';
            const customer = `Nº ${data.rent.number}${identification} - ${data.rent.customerSupplier.person.companyName}`;
            this.rent = { id: data.rent.id, content: customer };
        }

        this.launchProducts = data.launchProducts;
        this.deliveryDateHour = data.deliveryDateHour;
        this.startDateHour = data.startDateHour;
        this.endDateHour = data.endDateHour;
        this.devolutionDateHour = data.devolutionDateHour;
        this.observation = data.observation;
        this.archived = data.archived;
        this.total = data.total;
        this.totalPayment = data.totalPayment;
    }

}